import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setNewLineItems,
  setScheduleStep,
  setTotalPrice,
  setTotalTime,
  setTotalVehicles,
} from "../../../Store/Slice/scheduleSlice";
import Button from "../../../UI/Button";
import useSetLineItems from "../../../Global/Api/Schedule/setLineItems";
import Total from "./Total";
import RowItem from "./RowItem";
import useLineItemsCheck from "../../../Global/Api/Schedule/lineItemsCheck";
import {NavLink, useParams} from "react-router-dom";

export default function LineItemsInformation({accountData}) {
  const {title: jobTitle} = useParams();
  const dispatch = useDispatch();
  const lineItemsCheck = useLineItemsCheck();
  const setLineItems = useSetLineItems();
  const {activeJob} = useSelector((state) => state.rootReducer.jobsSlice);
  const lineItems = useSelector((state) => state.rootReducer.scheduleSlice.line_items);
  const totalTime = useSelector((state) => state.rootReducer.scheduleSlice.total_time);
  const scheduleStep = useSelector((state) => state.rootReducer.scheduleSlice.schedule_step);
  const totalVehicles = useSelector((state) => state.rootReducer.scheduleSlice.total_vehicles);
  const isRescheduleMode = jobTitle !== undefined;

  const isButtonDisabled = lineItems?.some((item) =>
    Object.values(item)?.some((value) => value === null || totalTime > 600)
  );

  const handleSubmit = (step) => {
    setLineItems.set(lineItems, totalVehicles);
    if (lineItemsCheck.check()) {
      dispatch(setScheduleStep(step));
    }
  };

  useEffect(() => {
    if (!jobTitle || !activeJob?.items) return;
    const {items} = activeJob;
    const formattedItems = items?.filter(el => Boolean(el?.id !== 0))?.map((item) => {
      const qty = item?.qty ?? 1;
      const unitPrice = item?.price ?? 0;
      const unitTime = item?.time ?? 0;
      return {
        id: item?.id,
        type_of_service: {
          value: item?.product_service_id,
          label: item?.product_service,
          is_main: true,
        },
        product: {
          value: item?.product_id,
          label: item?.product,
          image: item?.image,
        },
        quantity: qty,
        approximate_time: unitTime * qty,
        price: unitPrice * qty,
      };
    });
    dispatch(setNewLineItems({new_line_items: formattedItems ?? []}));
  }, [activeJob, jobTitle]);

  useEffect(() => {
    dispatch(setTotalVehicles());
    dispatch(setTotalPrice());
    dispatch(setTotalTime());
  }, [lineItems]);

  return (
    <div className={`schedule__block ${scheduleStep === 1 ? "active" : ""}`}>
      <h2 className="schedule__title">
        <div>1. Line items information</div>
        {scheduleStep !== 1 && !isRescheduleMode && (
          <span onClick={() => handleSubmit(1)}>Change</span>
        )}

        {scheduleStep !== 1 && isRescheduleMode && (
            <span onClick={() => handleSubmit(1)}>View</span>
        )}
      </h2>
      <div className="schedule__content">
        <div className="lineitems__table">
          <div className="lineitems__header">
            <div className="lineitems__row">
              <div className="lineitems__tr">Product</div>
              <div className="lineitems__tr">Type of service</div>
              <div className="lineitems__tr">Quantity</div>
              <div className="lineitems__tr">Price</div>
              <div className="lineitems__tr">Approximate time</div>
            </div>
          </div>
          <div className="lineitems__body">
            {lineItems?.map((item, index) => (
              <RowItem item={item} key={index} />
            ))}
          </div>
          <Total />
          <div className="lineitems__footer footer_s">
            <p>
             {
              ` For projects that exceed 50 ${accountData?.show_vehicle_forms ? 'vehicles' : 'main items'} or more and requires project
              management assistance,`
             } <br />
              go to the{" "}
              <NavLink target="_blank" to="/settings/faq">
                FAQ section
              </NavLink>{" "}
              for coordination assistance from the Techsbook Telematics team
            </p>
            <Button
              onClick={() => handleSubmit(2)}
              disabled={isButtonDisabled}
              text="Continue"
            />
          </div>
        </div>
      </div>
      {scheduleStep > 1 && <div className="schedule__hr"></div>}
      {scheduleStep > 1 && (
        <div className="schedule__footer">
          <div className="schedule__footer-item">Items: {lineItems.length}</div>
        </div>
      )}
    </div>
  );
}
